import { useMediaQuery } from 'react-responsive';
import { MOBILE_BREAKPOINT } from '#/units';

export default function useIsMobile() {
  return useMediaQuery({ query: `(max-width: ${MOBILE_BREAKPOINT}px)` });
}
